import { IAuthState } from '../types';

export function getEmptyAuthState(): IAuthState {
  return {
    accessToken: null,
    userProfile: null,
  };
}
